import { action } from 'typesafe-actions';

import { SearchsTypes, SearchItemsFilterInterface } from './types';

// Set Selected Items
export const setSelectedItems = (payload: {
  selectedItems: SearchItemsFilterInterface[];
}) => action(SearchsTypes.SET_SELECTED_ITEMS, payload);
